<template>
    <card :to="to" v-bind="cardProps">
        <card-image v-if="club.cover_image" :size="{ratio: 4, width: 192}" :src="club.cover_image" :style="{backgroundColor: club.color ?? '#bebebe'}" class="absolute top-0 w-full"/>
        <aspect-ratio-box v-else :ratio="4" :style="{backgroundColor: club.color ?? '#bebebe'}" class="absolute top-0 w-full opacity-75"/>

        <div class="w-full px-6 lg:px-8 pt-24 pb-16 border-box z-1">
            <div class="flex items-center justify-center mb-8 h-42">
                <div class="flex items-center justify-center relative h-full">
                    <avatar :model="club" :size="40" :color="club.avatar_thumbnail ? 'transparent' : 'gray-300'"/>
                    <tooltip v-if="club.verified" :text="$t('label.verified')" class="absolute bottom-0 right-0 mr--8 mb--4 bg-white rounded-full p-2">
                        <Icon :icon="icons.verified" color="success" x-small/>
                    </tooltip>
                </div>

                <chip v-if="distanceInKm" class="absolute top-0 left-0 m-8" x-small :icon="icons.location">{{ distanceInKm }} km</chip>
            </div>
            <div class="flex flex-column items-center w-full">
                <div class="flex items-center h-32">
                    <p class="mb-0 text-center w-full text-xs leading-normal truncate-2-lines" :class="{'text-heading-color': !club.color}" :style="{color: club.color}">
                        {{ asDepartment ? club.department_name : club.display_name }}</p>
                </div>

				<div class="flex flex-column items-center justify-center w-full h-32 text-2xs font-heading text-text-color text-center leading-normal">
					<span v-if="club.parent_club_id">{{ $t('label.department') }}</span>
					<template v-else-if="club.city">
						<span>{{ club.presentation_type_name }} {{ $t('conjunction.from') }}</span>
						<span class="w-full truncate">{{ club.city }}</span>
					</template>
					<span v-else>{{ club.presentation_type_name }}</span>
				</div>

                <div class="flex items-center h-28">
					<sport-type-text v-if="club.sportTypes && club.sportTypes.length" class="text-2xs text-center justify-center leading-normal text-subtext-color" :sport-types="club.sportTypes" :truncate="2"/>
				</div>

                <slot/>
            </div>
        </div>
    </card>
</template>

<script>
import CardMixin from "../../Card/CardMixin";
	import {mdiMapMarkerOutline, mdiShieldCheck} from "@mdi/js";
	import {locationIcon} from "../../../config";
    const Chip = () => import("../../Chip/Chip");

    export default {
        name: 'ClubCard',

        mixins: [CardMixin],

        props: {
            club: {
                type: Object,
                required: true
            },

            // The router navigation where to redirect the club when he clicks on the preview.
            to: {
                type: [String, Object],
                default: null
            },

            // Whether to show reduced club info for departments as the main club context is already given
            asDepartment: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                icons: {
                    verified: mdiShieldCheck,
					location: locationIcon,
                }
            }
        },

        computed: {

            distanceInKm() {
                const distanceInMeters = this.club.distance;

                if (!distanceInMeters) {
                    return null;
                }

                const distanceInKm = distanceInMeters / 1000;

                if (distanceInKm > 999) {
                    return null;
                }

                return Math.ceil(distanceInKm);
            },
        }
    }
</script>

